<template>
  <div>
    <v-card class="blueCard" flat>
      <v-card-title class="pa-2">
        <div class="d-flex flex-row align-start">
          <v-img
            height="40"
            class="mr-4"
            contain
            src="https://www.eyedock.com/images/menu_icons/meridian_calc_icon.svg"
          ></v-img>
          <div>Meridian Power Calculations</div>
        </div>

        <v-spacer class=""></v-spacer>
        <div class="text-center mx-auto mx-sm-0">
          <rx-paster
            class="mr-4 my-4 my-sm-2"
            :params="['small', 'block']"
            :types="['rx']"
            :imageIcon="true"
            buttonText="Parse Rxs from Text"
            buttonColor="#FFF"
            @pasted="pasted($event)"
          >
          </rx-paster>

          <div class="caption text-sm-right my-2">
            Round results to
            <v-btn-toggle
              v-model="round"
              rounded
              mandatory
              dense
              class="toggleBtns mx-2"
              active-class="orangeActive"
            >
              <v-btn small :value="0.01">0.01</v-btn>
              <v-btn small :value="0.125">0.125</v-btn>
              <v-btn small :value="0.25">0.25</v-btn>
            </v-btn-toggle>
          </div>
        </div></v-card-title
      >
    </v-card>

    <v-container
      ><v-row justify-center
        ><v-col cols="12" md="6">
          <v-container class="mt-6">
            <v-row no-gutters
              ><v-col
                v-for="eye in ['od', 'os']"
                :key="eye"
                cols="12"
                sm="5"
                md="6"
                class="pl-sm-5"
              >
                <rx-input
                  :eye="eye"
                  :rxString="rxString[eye]"
                  @rxChange="setRxObjFromInput($event, eye)"
                  :autofocus="true"
                />
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col
                v-for="eye in ['od', 'os']"
                :key="eye + '2'"
                cols="6"
                sm="5"
                md="6"
              >
                <optical-cross-image
                  :obj="rxObjects[eye]"
                  class="mx-auto"
                  :showHeatmap="true"
                  :dimensions="$vuetify.breakpoint.smAndUp ? 120 : 70"
                  type="rx"
                  :meridianMarker="meridian"
                ></optical-cross-image>
              </v-col>
              <!-- <v-col>{{ minMaxMeridianDiffs }}</v-col> -->
            </v-row>
            <v-row no-gutters>
              <v-col
                v-for="eye in ['od', 'os']"
                :key="eye + '2'"
                cols="6"
                sm="5"
                md="6"
                class="text-center"
              >
                <div
                  v-if="rxObjects[eye]"
                  class="title text-center d-flex flex-row justify-center align-center mt-6 mt-sm-0"
                >
                  <div>
                    {{
                      numToDiopterString(powerAtSelectedMeridian[eye], 1, round)
                    }}
                    D
                  </div>
                  <v-icon class="mx-2">mdi-at</v-icon>
                  <div>{{ numToAxisString(meridian) }}°</div>
                </div>
              </v-col>
            </v-row>
            <v-row justify-center>
              <v-col cols="12" sm="10" md="12" class="text-center"
                >Power difference at meridian
                {{ numToAxisString(meridian) }}&deg;:
                <span class="font-weight-bold embiggen">
                  {{
                    numToDiopterString(
                      Math.abs(
                        powerAtSelectedMeridian.od - powerAtSelectedMeridian.os
                      ),
                      0,
                      round
                    )
                  }}
                  D</span
                >
              </v-col></v-row
            >
            <v-row>
              <v-col
                cols="12"
                sm="10"
                md="12"
                style="text-align: center d-flex flex-row"
                class=""
              >
                <div>
                  <v-slider
                    v-model="sliderVal"
                    min="1"
                    max="180"
                    :hide-details="true"
                    :thumb-label="true"
                  >
                    <template v-slot:thumb-label>{{ meridian }}</template>

                    <template v-slot:prepend>
                      <div style="width: 80px">
                        <v-text-field
                          v-model="meridian"
                          label="Meridian"
                          type="number"
                          min="1"
                          max="180"
                          step="1"
                          outlined
                          dense
                          :hide-details="true"
                        ></v-text-field>
                      </div>
                    </template>
                  </v-slider>
                </div>

                <div class="mt-6 text-center">
                  <v-btn
                    v-for="btn in daButtons"
                    :key="btn.label"
                    depressed
                    class="mr-2 mb-2"
                    color="primary"
                    outlined
                    small
                    @click="meridian = btn.meridian"
                    >{{ btn.label }}</v-btn
                  >
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-col>
        <v-col cols="12" sm="12" md="3">
          <div class="mt-2 mt-sm-10">
            <v-card class="mb-4 infoBox ml-0 ml-sm-6" flat
              ><div class="title pa-2">Directions</div>
              <v-card-text>
                <ol>
                  <li>Type in the spectacle Rx for each eye</li>
                  <li>Type in (or drag the slider to) your desired meridian</li>
                  <li>
                    Or, use the buttons below the calculator to go to a common
                    meridian.
                  </li>
                </ol>

                <p>
                  <a href="/documentation/meridian-power-calculator"
                    >See the Meridian Power Calculator Documentation Page</a
                  >
                  for more information.
                </p></v-card-text
              ></v-card
            >
          </div>
        </v-col>
      </v-row></v-container
    >
    <!-- <div class="px-4">
      <v-btn
        v-for="btn in daButtons"
        :key="btn.label"
        depressed
        class="mr-2 mb-2"
        small
        @click="meridian = btn.meridian"
        >{{ btn.label }}</v-btn
      >
    
    </div> -->
    <!-- </div> -->
  </div>
</template>

<script>
import RxInput from "@/components/clStuff/RxInput.vue";
import RxMethods from "@/assets/js/cls/RxMethods";
import HashParserMixin from "@/assets/js/HashParserMixin";
import OpticalCrossImage from "@/components/clStuff/OpticalCrossImage";
import RxPaster from "@/components/clStuff/RxPaster.vue";

export default {
  name: "MeridianPowerCalcs",
  components: { RxInput, OpticalCrossImage, RxPaster },
  mixins: [RxMethods, HashParserMixin],
  props: {},
  data: function () {
    return {
      rxString: { od: "0", os: "0" },
      rxObjects: { od: null, os: null },
      meridian: 90,
      sliderVal: 90,
      round: 0.125,
    };
  },
  methods: {
    setRxObjFromInput(rxObj, eye) {
      // console.log(rxObj);
      this.rxObjects[eye] = rxObj;
      this.rxString[eye] = this.prettyString(rxObj); //rxObj.prettyString();
      // todo - error check
    },
    pasted(pastedObj) {
      if (pastedObj?.rx?.od) this.setRxObjFromInput(pastedObj.rx.od, "od");
      if (pastedObj?.rx?.os) this.setRxObjFromInput(pastedObj.rx.os, "os");
    },
  },
  computed: {
    powerAtSelectedMeridian() {
      let rtn = { od: 0, os: 0 };
      ["od", "os"].forEach((eye) => {
        rtn[eye] = this.powerAtMeridian(this.rxObjects[eye], this.meridian);
      });
      return rtn;
    },
    minMaxMeridianDiffs() {
      var biggestDiff = 0;
      var smallestDiff = 1000;
      var biggestDiffMeridian = 180;
      var smallestDiffMeridian = 180;
      for (var i = 0; i < 180; i++) {
        var odMeridianPower = this.powerAtMeridian(this.rxObjects.od, i);
        var osMeridianPower = this.powerAtMeridian(this.rxObjects.os, i);
        var diff = Math.abs(odMeridianPower - osMeridianPower);
        if (diff > biggestDiff) {
          biggestDiff = diff;
          biggestDiffMeridian = i;
        }
        if (diff < smallestDiff) {
          smallestDiff = diff;
          smallestDiffMeridian = i;
        }
      }
      return {
        minPowerDiff: smallestDiff,
        maxPowerDiff: biggestDiff,
        minDiffMeridian: smallestDiffMeridian,
        maxDiffMeridian: biggestDiffMeridian,
      };
    },
    daButtons: function () {
      let btns = [];
      btns.push({ meridian: 90, label: "Meridian 90°" });
      btns.push({ meridian: 180, label: "Meridian 180°" });
      btns.push({
        meridian: this.minMaxMeridianDiffs.minDiffMeridian,
        label: "Smallest Power Diff",
      });
      btns.push({
        meridian: this.minMaxMeridianDiffs.maxDiffMeridian,
        label: "Greatest Power Diff",
      });
      5;
      return btns;
    },
  },
  watch: {
    meridian(val) {
      this.sliderVal = 181 - val;
    },
    sliderVal(val) {
      this.meridian = 181 - val;
    },
  },
  mounted() {
    let hashParts = this.hashParts();
    let rxObjects = this.rxsFromHash(hashParts);
    if (!rxObjects) rxObjects = { od: null, os: null };
    if (!rxObjects.od) rxObjects.od = this.newRxObject();
    if (!rxObjects.os) rxObjects.os = this.newRxObject();

    this.setRxObjFromInput(rxObjects.od, "od");
    this.setRxObjFromInput(rxObjects.os, "os");
  },
};
</script>

<style scoped>
.colStyle {
  max-width: 45%;
  width: 250px;
}
</style>
